import { render, staticRenderFns } from "./CloudDiskBox.vue?vue&type=template&id=30d845aa&scoped=true"
import script from "./CloudDiskBox.vue?vue&type=script&lang=js"
export * from "./CloudDiskBox.vue?vue&type=script&lang=js"
import style0 from "./CloudDiskBox.vue?vue&type=style&index=0&id=30d845aa&lang=scss"
import style1 from "./CloudDiskBox.vue?vue&type=style&index=1&id=30d845aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d845aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\sdr\\KB\\Knowledge-base\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d845aa')) {
      api.createRecord('30d845aa', component.options)
    } else {
      api.reload('30d845aa', component.options)
    }
    module.hot.accept("./CloudDiskBox.vue?vue&type=template&id=30d845aa&scoped=true", function () {
      api.rerender('30d845aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/views/CloudDiskBox.vue"
export default component.exports